//https://diyhairpinlegs.herokuapp.com/api/product-group/hairpin-legs/variants

var ProductGroup = (function () {
    function ProductGroup(el) {
        this.$el = $(el);

        if( !(this.$el && this.$el.length) ) return;

        this.parentHandle = this.$el.data('pg-parent');
        this.currentVariant = (this.$el.data('product-current-variant'));
        this.product = {};
        this.mockColorImgUrl = this.$el.data('color-image-mock-url');

        this._init();
    }

    ProductGroup.prototype._init = function _init(){
        var _this = this;
        $.ajax({
            type: 'GET',
            url: `https://diyhairpinlegs.herokuapp.com/api/product-group/${this.parentHandle}/variants?minify=1`,
            dataType: 'json',
            beforeSend: function(){
                this.$el.addClass('loading');
            }.bind(this),
            complete: function(){
                this.$el.removeClass('loading');
            }.bind(this),
            success: function(product){
                _this.product = product;
                _this.currentVariant = _this._currentOrFirstVariant();

                _this._generateOptions();

                $('[data-product-json]').attr('data-product-json', JSON.stringify(product));
                $('[data-product-current-variant]').attr('data-product-current-variant', JSON.stringify(_this.currentVariant));

                $('[data-product]').trigger( "options:init" )
            }
        });
    }

    ProductGroup.prototype._currentOrFirstVariant = function _currentOrFirstVariant(){
        const queryParams = new URLSearchParams(window.location.search);
        if( queryParams.has('variant') ) {
            const qVariant = this.product.variants.find(function(_variant){
                return _variant.id == queryParams.get('variant');
            });
            if( qVariant )
                return qVariant;
        }
        
        return this.product.variants[0];
    }

    ProductGroup.prototype._generateOptions = function _generateOptions(){
        //
        let allOptions = "",
            isColor = false;
        //console.log('ads',this.product.options);
        //window.current_product_variants = this.product.variants;
        this.product.options.forEach((option, index) => {
            isColor = false;
            switch(option.name.toLowerCase()){
                case 'color':
                    isColor = true;
                case 'height':
				case 'length':
                case 'size':
                    option.values.sort(sortAlphaNum);
                    allOptions += this._generateSelectDropdown(option, index);
                    break;
                default:
                    allOptions += this._generateSwatch(option, index, isColor);
            }
        });
        this.$el.html(`<div class="product-swatches">${allOptions}</div>` + this._generateVariantSelector());
    }

    ProductGroup.prototype._generateSelectDropdown = function _generateSelectDropdown(option, optionIndex){
        const product_id = this.product.id;
        const variant = this.currentVariant;
        const selectedOptionValue = variant[`option${optionIndex+1}`];
        option.values = option.values.sort();
        
        return `<div class="form-field form-field-swatch swatch-other" data-product-swatch="${optionIndex}">
        <span class="form-field-title">${option.name}</span>
        <div class='form-select-wrapper'><select class="form-swatch-item" data-product-swatch-input name='${product_id}-option-${optionIndex}'>` + option.values.map(value => `<option data-product-swatch-value='${value}' ${selectedOptionValue === value ? 'selected=""' : ''} value='${(value)}' >${value}</option>`).join('') +
        `</select></div>
        </div>`;
    }

    ProductGroup.prototype._generateSwatch = function _generateSwatch(option, optionIndex, isColor){
        const _this = this, product_id = this.product.id;
        const variant = this.currentVariant;
        window.current_product_variants = _this.product.variants;
        const selectedOptionValue = variant[`option${optionIndex+1}`];
        option.values = option.values.sort();
        //console.log('VAR SWATCH', option, selectedOptionValue)
        return `<div class="form-field form-field-swatch swatch-${isColor ? 'color': 'other'}" data-product-swatch="${optionIndex}">
        <span class="form-field-title">${option.name}</span>` +
            option.values.map(function(value) {
                return `<div class="form-swatch-item ${selectedOptionValue === value ? 'available' : ''}" data-product-swatch-value='${(value)}'>
                ${isColor ? "<div class='tooltip'>" + value + "</div>" : ""}
                <input class="form-radio" id="${product_id}-option-${optionIndex}-${handleize(value)}" type="radio" name="${product_id}-option-${optionIndex}" value='${(value)}' ${selectedOptionValue === value ? 'checked=""' : ''} data-product-swatch-input='${(value)}'>
                <label for="${product_id}-option-${optionIndex}-${handleize(value)}" ${isColor ? 'style="background-color: ' + handleize(value.split(' ').pop()) + '; background-position: center; background-image:url(' + _this._getColorImageUrl(handleize(value)) + ');"' : ''} aria-label="${value}">${isColor ? '' : value}</label>
              </div>`;
            }).join('')
      + `</div>`;
    }

    ProductGroup.prototype._generateVariantSelector = function() {
        const currentVariant = this.currentVariant;
        return `<div class="form-field product-select-simple-wrapper">
        <label for="product-select-simple">
            <select id="product-select-simple" class="product-select-simple no-wrap" name="id">
            ${this.product.variants.map(variant => {
                return `<option value='${variant.id}' ${currentVariant.id === variant.id ? 'selected=""' : ''}>${variant.title}</option>`;
            }).join('')}
            </select>
        </label>
        </div>`;
    }

    ProductGroup.prototype._getColorImageUrl = function _getColorImageUrl(color) {
        return this.mockColorImgUrl.replace('mock-image', color).split('?')[0];
    }

    return ProductGroup;
})();

function handleize(str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
    
    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    return str
};

function sortAlphaNum(a, b) {
    var aA = a.replace(/[^a-zA-Z]/g, "");
    var bA = b.replace(/[^a-zA-Z]/g, "");
    if (aA === bA) {
      var aN = parseInt(a.replace(/[^0-9]/g, ""), 10);
      var bN = parseInt(b.replace(/[^0-9]/g, ""), 10);
      return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
      return aA > bA ? 1 : -1;
    }
}

$(function(){
    new ProductGroup('[data-pg-parent]');
});